export const getIncomeTaxCalculator = state => state.incomeTaxCalculator;